import { render, staticRenderFns } from "./WsCarousel.vue?vue&type=template&id=88a3767a&scoped=true&"
import script from "./WsCarousel.vue?vue&type=script&lang=js&"
export * from "./WsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./WsCarousel.vue?vue&type=style&index=0&id=88a3767a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a3767a",
  null
  
)

export default component.exports